<template>
    <div class="HomePage">

		<!-- CAROUSEL -->
		<Carousel />

		<!-- CARDS -->
		<Cards />

		<!-- OFFERS -->
		<Offers />

  	</div>
</template>

<script>
import Carousel from '@/components/Carousel'
import Cards from '@/components/Cards'
import Offers from '@/components/Offers'

export default {
	name: 'HomePage',
	components: {
		Carousel,
		Cards,
		Offers
	}

}
</script>

<style lang="scss" scoped>

.HomePage {
	min-height: 85vh;
	padding-top: 80px;
}

.cards_container {
	width: 100%;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	padding: 20px 0;
}

</style>
